const tutorialTypes = {
    VIEWED_TUTORIAL: '[TUTORIAL] VIEWED_TUTORIAL',
    SHOW_TUTORIAL: '[TUTORIAL] SHOW_TUTORIAL',
};
export default tutorialTypes;
